import "@popperjs/core";
import "bootstrap";
import "../styles/index.scss";
import { ChartJsInterop } from "./chartjsInterop";

(<any>window).chartjsInterop = new ChartJsInterop();